import React from 'react';
import './Solutions.css';

const solutions = [
  {
    title: '审计全流程',
    items: ['数据采集与清洗', '智能分析', '报告生成'],
  },
  {
    title: '行业定制',
    items: ['金融审计', '企业内控', '政府审计'],
  },
  {
    title: '技术创新',
    items: ['NLP算法', '机器学习', '低代码平台'],
  },
];

const Solutions: React.FC = () => (
  <section className="solutions">
    <h2>全场景解决方案</h2>
    <div className="solutions-list">
      {solutions.map((sol, idx) => (
        <div className="solution-card" key={idx}>
          <h3>{sol.title}</h3>
          <ul>
            {sol.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </section>
);

export default Solutions; 